module.exports = __webpack_public_path__ + "img/p2.ce6b56f8.png";